module.exports = __webpack_public_path__ + "static/media/18.f0ca3db6.jpg";